import createAction from './utils/createAction';
import buildValidation from './utils/buildValidation';

/**
 * Ingests standard uiConfig and translates the format into one that is
 * useable by our general Table element.
 * @param uiConfig
 * @param addEdit (event handler for onClick for add and edit)
 * @param deleteEntry (event handler for onClick of delete)
 * @returns {{columns: [string, any], actions: Array}|{columns: [string, any], actions: null}}
 */
const translateUIConfigForTable = (
    uiConfig,
    addEdit = null,
    deleteEntry = null,
    selectEntry = null,
    exportEntry = null,
    copyEntry = null
) => {
    const initialState =
        uiConfig?.sortBy && typeof uiConfig.sortBy === 'object' && uiConfig.sortBy?.columnId
            ? {
                  sortBy: [
                      {
                          id: uiConfig.sortBy.columnId,
                          desc: !!uiConfig.sortBy.desc
                      }
                  ]
              }
            : {};

    let propertyRows = Object.entries(uiConfig.properties).reduce((agg, [k, v], i) => {
        if (v.rowDisplay === true) {
            agg.push({
                Header: v.name,
                accessor: typeof v.accessorOverride !== 'undefined' ? v.accessorOverride : k,
                filterable: !!v.filterable,
                ...(v.additionalProperties || {})
            });
        }
        return agg;
    }, []);

    if (
        typeof uiConfig.withActions === 'object' &&
        Array.isArray(uiConfig.withActions) &&
        uiConfig.withActions.length > 0
    ) {
        let actions = [];
        for (let action of uiConfig.withActions) {
            let actionItem = createAction(action, addEdit, deleteEntry, selectEntry, exportEntry, copyEntry);
            if (actionItem !== null) {
                actions.push(actionItem);
            }
        }
        if (actions.length) {
            propertyRows.push({
                Header: ``,
                accessor: `DataTableActions`,
                disableSortBy: true,
                DataTableActions: true,
                filterable: false
            });
            return {
                columns: propertyRows,
                actions,
                initialState
            };
        }
    }

    return {
        columns: propertyRows,
        actions: null,
        initialState: {}
    };
};

/**
 * Function ingests a uiConfig object and translates the format into that which can be leveraged by our universal form controller.
 * @param uiConfig
 * @returns {[string, any]}
 */
const translateUIConfigForAddEdit = (uiConfig) => {
    return Object.entries(uiConfig.properties)
        .filter(([k, v]) => ['string', 'function'].includes(typeof v.input))
        .reduce((agg, [k, v], i) => {
            // if (k === 'deploymentEnvironment') {
            //     debugger;
            // }
            agg.push({
                label: typeof v.inputLabel !== 'undefined' ? v.inputLabel : v.name,
                accessor: k,
                input: v.input,
                options: v.options,
                preChangeBind: v.preChangeBind,
                postChangeBind: v.postChangeBind,
                validation: buildValidation(v),
                ...v
            });
            return agg;
        }, []);
};

/**
 *
 * @param uiConfig
 * @param data
 * @returns {[string, any]}
 */
const translateFormDataForReadOnlyForm = ({ uiConfig = {}, data = {} }) => {
    return Object.entries(uiConfig.properties)
        .filter(([k, v]) => ['string', 'function'].includes(typeof v.input))
        .reduce(
            (agg, [k, v], i) => ({
                ...agg,
                [k]: typeof v.accessorOverride === 'function' ? v.accessorOverride(data) : data[k]
            }),
            {}
        );
};

export { translateUIConfigForAddEdit, translateUIConfigForTable, translateFormDataForReadOnlyForm };
